module.exports = __webpack_public_path__ + "68214484c26ae6d45ee37ce7ef716e34.png";